export const LIB_KEY = "i18nextLng";
export const CUSTOM_KEY = "i18nCurrentLng";
export const LANGUAGES = ["en", "da"];
